import { buildApiUrl } from "./apiConfig";

const ensureFetcher = (fetchWithAuth) => {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required.");
  }
  return fetchWithAuth;
};

export async function fetchPlatformSettings(fetchWithAuth) {
  const runner = ensureFetcher(fetchWithAuth);
  const res = await runner(buildApiUrl("/admin/platform-settings"));
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Einstellungen konnten nicht geladen werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.settings ?? [];
}

export async function savePlatformSettings(fetchWithAuth, settings) {
  if (!Array.isArray(settings)) {
    throw new Error("settings must be an array");
  }
  const runner = ensureFetcher(fetchWithAuth);
  const res = await runner(buildApiUrl("/admin/platform-settings"), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ settings }),
  });
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Einstellungen konnten nicht gespeichert werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.settings ?? [];
}
